export default "__VITE_ASSET__BG$QgpLo__"